import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  constructor() {}

  public currentStep = new BehaviorSubject(1);
}
